import React from "react";
import { TrendingUp, Check } from "lucide-react";

export const TrendingIdeasPicker = ({ ideas = [], selectedIndex, onSelect, loading = false }) => {
  if (!ideas.length && !loading) return null;

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2">
        <TrendingUp className="h-3.5 w-3.5 text-emerald-400" strokeWidth={2} />
        <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-400">
          5 ideas grounded in live trends · pick one
        </h3>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {ideas.map((idea, i) => {
          const isSel = i === selectedIndex;
          return (
            <button
              key={i}
              type="button"
              onClick={() => onSelect(i)}
              data-testid={`trending-idea-${i}`}
              className={`text-left rounded-2xl border p-4 transition-all duration-200 hover:-translate-y-0.5 ${
                isSel
                  ? "border-amber-500/60 bg-amber-500/10 ring-2 ring-amber-500/30"
                  : "border-white/10 bg-zinc-900/60 hover:border-amber-500/40"
              }`}
            >
              <div className="flex items-start justify-between gap-2 mb-1.5">
                <span className="inline-flex items-center gap-1.5 rounded-full border border-emerald-500/30 bg-emerald-500/10 px-2 py-0.5 text-[9px] font-bold uppercase tracking-[0.22em] text-emerald-300">
                  {idea.category || "trend"}
                </span>
                {isSel && (
                  <span className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-[0.2em] text-amber-300">
                    <Check className="h-3 w-3" strokeWidth={2.5} />
                    Selected
                  </span>
                )}
              </div>
              <div className="font-display text-base font-bold text-white leading-snug">
                {idea.niche}
              </div>
              <div className="mt-1.5 text-xs text-zinc-400 leading-relaxed">
                {idea.hook_insight}
              </div>
              {idea.product_angle && (
                <div className="mt-2 text-[11px] text-zinc-500">
                  <span className="text-zinc-400 font-semibold">Angle: </span>
                  {idea.product_angle}
                </div>
              )}
              {idea.audience_shortline && (
                <div className="mt-1 text-[11px] text-zinc-500">
                  <span className="text-zinc-400 font-semibold">For: </span>
                  {idea.audience_shortline}
                </div>
              )}
              {idea.trending_source && (
                <div className="mt-2 text-[10px] text-emerald-300/80 italic">
                  via {idea.trending_source}
                </div>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default TrendingIdeasPicker;
